var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-btn",class:{ disabled: _vm.disabled || _vm.loading },on:{"click":_vm.clickRight}},[(_vm.loading)?_c('Loading',{attrs:{"color":"white","type":"spinner","size":"18px"}}):_c('img',{attrs:{"src":require("./img/right.png"),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }